// axios
import axios from 'axios'

const baseURL = 'https://t2c.arqbs.com/Time2ChangeRestFiles' //'http://129.213.125.166:9092/Time2ChangeRestFiles'

//const baseURL_V2 = 'https://t2c-prd.saas.arqbs.com/Time2ChangeRestFiles'

export default axios.create({
  baseURL
  //baseURL_V2
  // You can add your headers here
})
